import _inheritsLoose from "@babel/runtime/helpers/inheritsLoose";
import React, { Component } from "react";
import { Icon } from "@icg360/design-system";
import { pacDataPropTypes } from "../../shared/propTypes";
import { formatValue } from "../../shared/utils";
import styles from "./SupplementalPolicyData.styles";

var SupplementalPolicyData = /*#__PURE__*/function (_Component) {
  _inheritsLoose(SupplementalPolicyData, _Component);

  function SupplementalPolicyData(props) {
    var _this;

    _this = _Component.call(this, props) || this;

    _this.handleExpandCollapse = function (e) {
      e.preventDefault();

      _this.setState({
        isExpanded: !_this.state.isExpanded
      });
    };

    _this.state = {
      isExpanded: true
    };
    return _this;
  }

  var _proto = SupplementalPolicyData.prototype;

  _proto.render = function render() {
    var isExpanded = this.state.isExpanded;
    var _this$props$pacData = this.props.pacData,
        policyData = _this$props$pacData.policyData,
        supplementalPolicyTerms = _this$props$pacData.supplementalPolicyTerms; // If there is no `supplementalPolicyTerms` then we don't show anything, as
    // some forms don't have anything to show.

    if (!supplementalPolicyTerms) {
      return null;
    } // If the network call fails, or for some reason the context is missing,
    // we'll get empty data, in which case we want to show a failed state.


    if (supplementalPolicyTerms.length === 0) {
      return /*#__PURE__*/React.createElement("div", {
        className: "text-muted",
        style: styles.emptyText
      }, "Supplemental policy terms failed to load. If this problem persists, please contact support.");
    }

    var collapsedPanelClasses = ["panel-collapse", "collapse", isExpanded ? "in" : ""].join(" ");
    return /*#__PURE__*/React.createElement("div", {
      style: styles.container
    }, /*#__PURE__*/React.createElement("div", {
      className: "panel panel-default",
      style: styles.panel
    }, /*#__PURE__*/React.createElement("div", {
      className: "panel-heading"
    }, /*#__PURE__*/React.createElement("span", {
      className: "panel-title",
      style: styles.panelTitle
    }, /*#__PURE__*/React.createElement("div", {
      onClick: this.handleExpandCollapse,
      style: styles.header
    }, "Supplemental Policy Data", isExpanded ? /*#__PURE__*/React.createElement("div", {
      style: styles.iconArrow
    }, /*#__PURE__*/React.createElement(Icon, {
      name: "ArrowUp",
      size: "xs"
    })) : /*#__PURE__*/React.createElement("div", {
      style: styles.iconArrow
    }, /*#__PURE__*/React.createElement(Icon, {
      name: "ArrowDown",
      size: "xs"
    }))))), /*#__PURE__*/React.createElement("div", {
      className: collapsedPanelClasses,
      id: "panel-content"
    }, /*#__PURE__*/React.createElement("div", {
      className: "panel-body"
    }, /*#__PURE__*/React.createElement("div", {
      className: "row"
    }, supplementalPolicyTerms.map(function (category) {
      return /*#__PURE__*/React.createElement("div", {
        className: "col-xs-6",
        key: category.label
      }, /*#__PURE__*/React.createElement("strong", null, category.label), /*#__PURE__*/React.createElement("ul", {
        className: "list-unstyled"
      }, category.terms.map(function (term) {
        return /*#__PURE__*/React.createElement("li", {
          key: term.name,
          style: styles.li
        }, /*#__PURE__*/React.createElement("span", {
          className: "text-muted",
          title: term.name,
          style: styles.left
        }, term.label), /*#__PURE__*/React.createElement("span", {
          className: "text-right",
          style: styles.right
        }, policyData[term.name] ? formatValue(policyData[term.name], term.dataType, term.enumerations) : /*#__PURE__*/React.createElement("span", {
          style: {
            opacity: ".5"
          }
        }, "N/A")));
      })));
    }))))));
  };

  return SupplementalPolicyData;
}(Component);

SupplementalPolicyData.propTypes = {
  pacData: pacDataPropTypes.isRequired
};
export { SupplementalPolicyData as default };